var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#follow_svg__clip0_14183_2149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.172 9.625a4.081 4.081 0 014.078 4.078.81.81 0 01-.82.797H1.547a.79.79 0 01-.797-.797c0-2.25 1.805-4.078 4.055-4.078h2.367zm3.258 4.125c.023 0 .07-.023.07-.047a3.34 3.34 0 00-3.328-3.328H4.805c-1.828 0-3.305 1.5-3.305 3.328a.05.05 0 00.047.047h8.883zM6 8.5a2.99 2.99 0 01-3-3c0-1.64 1.336-3 3-3 1.64 0 3 1.36 3 3 0 1.664-1.36 3-3 3zm0-5.25A2.266 2.266 0 003.75 5.5 2.25 2.25 0 006 7.75 2.266 2.266 0 008.25 5.5c0-1.219-1.031-2.25-2.25-2.25zm9.375 4.125c.188 0 .375.188.375.375 0 .21-.188.375-.375.375h-1.5v1.5c0 .21-.188.375-.375.375a.37.37 0 01-.375-.375v-1.5h-1.5a.37.37 0 01-.375-.375c0-.188.164-.375.375-.375h1.5v-1.5c0-.188.164-.375.375-.375.188 0 .375.188.375.375v1.5h1.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "follow_svg__clip0_14183_2149"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.25)",
    d: "M0 0h16v16H0z"
  })))));
}
export default SvgFollow;